import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Divider,
  FormControl,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import { useMutation, useLazyQuery } from "@apollo/client";
import { toggleSnackbar } from "../../RactiveVariables";
import { GET_ALL_SCHOOL_USER, LIST_ATTENDEES } from "../../Graphql/queries";
import { TRANSFER_ATTENDEES } from "../../Graphql/mutations";
export default function TransferAttendee(props) {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState("");
  const [transferAttendees, { loading }] = useMutation(TRANSFER_ATTENDEES, {
    refetchQueries: ["listAllOrderTicket"],
    onCompleted: (res) => {
      setUser("");
      props?.setOpen(false);
      toggleSnackbar({
        status: true,
        message: res?.transferAttendees.message,
        variant: res?.transferAttendees.status == true ? "success" : "error",
      });
    },
  });
  // const [getAllUsers, { loading: usersLoading }] = useLazyQuery(
  //   GET_ALL_SCHOOL_USER,
  //   {
  //     fetchPolicy: "network-only",
  //     onCompleted: (res) => {
  //       let userArr = [];
  //       res?.listAllSchUsers?.data?.forEach((element) => {
  //         if (props?.selectedUser && element?._id != props?.selectedUser?._id)
  //           userArr.push({
  //             _id: element._id,
  //             name: element?.firstName + " " + element?.lastName,
  //           });
  //       });
  //       setUsers(userArr);
  //     },
  //   }
  // );
  const [getAllAttendees, { data: attendeesData, loading: attendeesLoading }] =
    useLazyQuery(LIST_ATTENDEES, {
      fetchPolicy: "network-only",
      onCompleted: (res) => {
        let userArr = [];
        res?.attendeesList?.forEach((element) => {
          userArr.push({
            _id: element._id,
            name: element?.firstName + " " + element?.lastName,
          });
        });
        setUsers(userArr);
      },
    });

  useEffect(() => {
    if (props?.selectedItem?.orderId && props?.open) {
      getAllAttendees({
        variables: {
          orderId: props?.selectedItem?.orderId,
        },
      });
      // getAllUsers({
      //   variables: {
      //     schId: props?.selectedItem?.schoolId,
      //     idType: "schoolId",
      //   },
      // });
    }
  }, [props?.selectedItem?.schoolId, props?.selectedUser, props?.open]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  function handleTransfer() {
    transferAttendees({
      variables: {
        eventId: props?.selectedItem?.eventId,
        orderId: props?.selectedItem?.orderId,
        orderNo: props?.selectedItem?.orderDtls?.orderNo,
        schoolId: props?.selectedItem?.schoolId,
        prevUserId: props?.selectedUser?._id,
        newUserId: user,
        ticketId: props?.selectedItem?._id,
      },
    });
  }

  function handleClose() {
    props?.setOpen(false);
    setUser("");
  }
  function handleUsers(params) {
    setUser(params?.target?.value);
  }
  return (
    <div>
      <Modal
        className="modal-outer"
        open={props?.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
      >
        <Box sx={style} className="refund-modal">
          <div className="refund-top">
            <h1 className="modal-title">
              Do you really want to transfer {props?.selectedUser?.firstName} ?
            </h1>
          </div>
          <Divider />
          <div className="refund-bottom">
            <p className="refund-note">
              Please choose a new Participant for transfer
            </p>
            <Box sx={{ minWidth: 177 }}>
              <FormControl fullWidth>
                <Select
                  className="filter-select"
                  labelId="user"
                  id="demo-user"
                  value={user}
                  label="user"
                  onChange={handleUsers}
                >
                  {attendeesLoading && <MenuItem disabled>Loading...</MenuItem>}
                  {users.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <div className="btn-section">
              <button
                className="btn  outline-btn font-weight-bold mt-3 w-25"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                disabled={loading || user === ""}
                className="btn btn-orange font-weight-bold mt-3 w-25"
                onClick={handleTransfer}
              >
                {loading ? (
                  <CircularProgress size="20px" color="inherit" />
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
